import { somenteDigitos } from "./camposAtualizacaoCadastral";

/*
 * Busca de endereco por CEP no ViaCEP (o mesmo servico usado pela integracao Omie).
 * E so uma ajuda ao preenchimento: se o servico falhar, o usuario digita o endereco normalmente.
 */

const URL_VIA_CEP = "https://viacep.com.br/ws";
const TEMPO_LIMITE_MS = 5000;

export interface EnderecoCep {
  logradouro: string;
  bairro: string;
  cidade: string;
  uf: string;
}

/** @return o endereco do CEP, ou null quando o CEP nao existe no ViaCEP */
export const buscarEnderecoPorCep = async (cep: string): Promise<EnderecoCep | null> => {
  const digitos = somenteDigitos(cep);
  if (digitos.length !== 8) {
    return null;
  }
  const controle = new AbortController();
  const tempoLimite = setTimeout(() => controle.abort(), TEMPO_LIMITE_MS);
  try {
    const resposta = await fetch(`${URL_VIA_CEP}/${digitos}/json/`, { signal: controle.signal });
    if (!resposta.ok) {
      throw new Error(`ViaCEP respondeu ${resposta.status}`);
    }
    const dados = await resposta.json();
    if (!dados || dados.erro) {
      return null;
    }
    return {
      logradouro: dados.logradouro || "",
      bairro: dados.bairro || "",
      cidade: dados.localidade || "",
      uf: dados.uf || "",
    };
  } finally {
    clearTimeout(tempoLimite);
  }
};
